import { render, staticRenderFns } from "./AdvancedSearch.vue?vue&type=template&id=3fafcede&scoped=true"
import script from "./AdvancedSearch.vue?vue&type=script&lang=js"
export * from "./AdvancedSearch.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSearch.vue?vue&type=style&index=0&id=3fafcede&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fafcede",
  null
  
)

export default component.exports